const noCssLinkTag = {
  textDecoration: 'none',
  color: 'inherit',
};

export default noCssLinkTag;
